import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import Switch from 'react-bootstrap-switch';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import Modal from 'react-bootstrap/Modal';
import ModalSetCourse from '../modal/ModalSetCourse';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'doc_status',
    render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        if (data === true)
          return `<div class="custom-control custom-switch"><input id="customSwitch_${row.TRAINING_ID}" type="checkbox" class="custom-control-input" checked/><label class="custom-control-label" for="customSwitch_${row.TRAINING_ID}"></label></div>`;
        else
          return `<div class="custom-control custom-switch"><input id="customSwitch_${row.TRAINING_ID}" type="checkbox" class="custom-control-input"/><label class="custom-control-label" for="customSwitch_${row.TRAINING_ID}"></label></div>`;
      }
      return data;
    }
  },
  {
    title: 'เลขเอกสาร',
    data: 'TRAINING_ID'
  },
  {
    title: 'หัวข้อ',
    data: 'doc_name_th'
  },
  {
    title: 'โดย',
    data: 'doc_by'
  },
  {
    title: 'กลุ่มเป้าหมาย',
    data: 'doc_target'
  },
  {
    title: 'สร้าง PDF หรือไม่',
    data: 'doc_gen_pdf'
  },
  {
    title: 'วันที่สร้าง',
    data: 'date_insert'
  },
  {
    title: 'ลิงค์เอกสาร',
    data: 'doc_pdf_path',
      render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        return `<a href="${data}" target="_blank" id="${row.TRAINING_ID}_blank">กดดู</a>`;
      }
      return data;
    }
  },
  {
    title: 'View',
    data: 'TRAINING_ID',
    render: function (data, type) {
      if (type === 'display') {
        return `<a class="btn btn-outline-secondary btn-sm" id="${data}_view"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  }
];

function reloadTableData(names, page) {
  console.log('reload: ' + names.length);
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(names);
  table.draw();
  table.page(page).draw('page');
  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

class TableReport3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {USERNAME: 'HI'},
      onUpdate: () => {},
      // showMd: false
    };
    // this.selectRow = this.selectRow.bind(this);
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.names,
      columns,
      searching: true,
      order: [[6, 'desc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      errMode: 'none',
      scrollX: true
      // responsive: true,
      // columnDefs: [
      //   {target: 0, responsivePriority: 1},
      //   {target: 1, responsivePriority: 1},
      //   {target: 2, responsivePriority: 2},
      //   {target: 3, responsivePriority: 2},
      //   {target: 4, responsivePriority: 2},
      //   {target: 5, visible: false},
      //   {targets: -1, responsivePriority: 1}
      // ]
    });

    table.on('page', (event) => {
      var info = table.page.info();
      console.log(info.page);
      this.props.onPageChange(info.page);
    });

    $.fn.dataTable.ext.errMode = 'none';

   $(`#${id} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();

      if ($this.attr('id').split('_')[1] === 'view') {
        this.props.onToggle(data, true);
      }
    });

    $(`#${id} tbody`).on('change', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.setState({
        item: {
          ...data,
          UPDATE_ON: 'MAIN',
          doc_status: $this.prop('checked') === true ? '1' : '0'
        }
      });
      this.state.onUpdate({
        ...data,
        UPDATE_ON: 'MAIN',
        doc_status: $this.prop('checked') === true ? '1' : '0'
      });
    });

    this.setState({
      onUpdate: (item) => {
        this.props.onUpdate(item);
      }
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names, nextProps.page);
    // } else {
      // updateTable(nextProps.names, nextProps.page);
    // }
    return true;
  }

  render() {
    return (
      <div>
        <table
          ref="main"
          className="display nowrap example"
          id={id}
          style={{width: '100%'}}
        />
      </div>
    );
  }
}
export default TableReport3;
